import '.bn{position:relative;}.ssr-plugin'
import '.a4{width:100%;}.ssr-plugin'
import '.gj{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.c8{align-items:flex-start;}.ssr-plugin'
import '.t{padding:2rem;}.ssr-plugin'
import '.cs{background:var(--shades-white);}.ssr-plugin'
import '.l{overflow:hidden;}.ssr-plugin'
import '.h{position:absolute;}.ssr-plugin'
import '.io{top:50%;}.ssr-plugin'
import '.ip{right:1rem;}.ssr-plugin'
import '.iq{transform:translateY(-50%);}.ssr-plugin'
import '.ir{width:120px;}.ssr-plugin'
import '.is{height:120px;}.ssr-plugin'
import '.it{z-index:0;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.hk{z-index:1;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.iu{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bn a4 gj a m b c8 t cs l"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="h io ip iq ir is it a n b"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bn hk a m c8 aj iu"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
